import React from "react";
import { Card } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import './OpalAccordionCardV4.css';

const OpalAccordionCardV4 = ({
    item,
    selectedCard,
    setSelectedCard,
    search,
    onSelectItem,
    onDeleteItem
}) => {

    const getInitials = (name) => {
        if (!name) return "";

        const parts = name.trim().split(/\s+/);

        if (parts.length === 1) {
            return parts[0][0].toUpperCase();
        }

        const firstInitial = parts[0][0];
        const lastInitial = parts[parts.length - 1][0];

        return (firstInitial + lastInitial).toUpperCase();
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "InCoverage":
                return "#C22020";   // Red
            case "Started":
                return "#069D33";   // Green
            case "Ended":
                return "#8000FF";   // Purple
            case "Offline":
                return "#A09E9E";   // Gray
            default:
                return "#A09E9E";
        }
    };

    const statusColor = getStatusColor(item?.status);

    return (
        <Card key={item?.employee?.id}
            className="card-v4 mb-2"
            onClick={() => {
                setSelectedCard(item?.employee?.id);
                onSelectItem(item?.employee?.id);
            }}>
            <div
                className={`custom-card mb-2 card-body ${selectedCard === item?.employee?.id ? "active-card" : ""} p-3`}
                style={{ "--border-type-color": statusColor }}>
                <div className="d-flex align-items-center">
                    <div className="circle-counter flex-shrink-0 me-3 me-md-2 me-lg-3">
                        {getInitials(item?.employee.name)}
                    </div>
                    <div>
                        <Card.Title>
                            {item?.employee.name?.toUpperCase()}
                        </Card.Title>
                        <div className="d-flex justify-content-between">
                            <Card.Text>
                                {item?.territory}
                            </Card.Text>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OpalAccordionCardV4;
